"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _striptags = _interopRequireDefault(require("striptags"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _cccisdFormik = require("cccisd-formik");
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down8"));
var _arrowDown2 = _interopRequireDefault(require("cccisd-icons/arrow-down5"));
var _backspace = _interopRequireDefault(require("cccisd-icons/backspace"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right8"));
var _arrowRight2 = _interopRequireDefault(require("cccisd-icons/arrow-right5"));
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _arrowUp = _interopRequireDefault(require("cccisd-icons/arrow-up8"));
var _arrowUp2 = _interopRequireDefault(require("cccisd-icons/arrow-up5"));
var _warning = _interopRequireDefault(require("cccisd-icons/warning"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _helpers = require("../Pinned/helpers");
var _IconField = _interopRequireDefault(require("../IconField"));
var _Advanced = _interopRequireDefault(require("./Advanced.js"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var ModuleContent = function ModuleContent(_ref) {
  var assignmentData = _ref.assignmentData,
    deleteModule = _ref.deleteModule,
    formikBag = _ref.formikBag,
    hasError = _ref.hasError,
    index = _ref.index,
    isEnglish = _ref.isEnglish,
    isExpanded = _ref.isExpanded,
    isSpanish = _ref.isSpanish,
    module = _ref.module,
    setIsExpanded = _ref.setIsExpanded,
    surveys = _ref.surveys;
  var values = formikBag.values;
  var prefix = "".concat(values.currentPrefix, ".modules.").concat(index);
  var wysiwygToolbar = ['styleselect bold italic underline | forecolor backcolor | table | code | cccisdAudio cccisdWordTimings cccisdImageResource cccisdBackground cccisdVariables | cccisdTooltip cccisdInformation cccisdIcons'];
  var displayHeader = 'MODULE ' + module.id;
  var displayTitle = '';

  // Empty string means it's intentionally empty and should not be rendered
  // Absence of key in settings means to fallback to default
  if ('headerEn' in module) {
    var _module$headerEn;
    displayHeader = (0, _striptags["default"])(((_module$headerEn = module.headerEn) === null || _module$headerEn === void 0 ? void 0 : _module$headerEn.content) || module.headerEn).replace(/&nbsp;/g, ' ').replace(/\*/g, '');
  } else if ('headerEs' in module) {
    var _module$headerEs;
    displayHeader = (0, _striptags["default"])(((_module$headerEs = module.headerEs) === null || _module$headerEs === void 0 ? void 0 : _module$headerEs.content) || module.headerEs).replace(/&nbsp;/g, ' ').replace(/\*/g, '');
  }
  if ('titleEn' in module) {
    var _module$titleEn;
    displayTitle = (0, _striptags["default"])(((_module$titleEn = module.titleEn) === null || _module$titleEn === void 0 ? void 0 : _module$titleEn.content) || module.titleEn).replace(/&nbsp;/g, ' ').replace(/\*/g, '');
  } else if ('titleEs' in module) {
    var _module$titleEs;
    displayTitle = (0, _striptags["default"])(((_module$titleEs = module.titleEs) === null || _module$titleEs === void 0 ? void 0 : _module$titleEs.content) || module.titleEs).replace(/&nbsp;/g, ' ').replace(/\*/g, '');
  }
  function removeLesson(fieldArrayBag, surveyHandles, handle) {
    fieldArrayBag.form.setFieldValue(fieldArrayBag.name, surveyHandles.filter(function (h) {
      return h !== handle;
    }));
    (0, _helpers.deletePinnedContentLesson)(formikBag, index, handle);
    fieldArrayBag.form.setFieldTouched('lessonsChanged', true);
  }
  function renderIconFields() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].twoColumnForm
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].field
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: prefix + '.iconEn',
      component: _IconField["default"],
      label: "Icon (En)",
      disabled: !isEnglish
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].field
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: prefix + '.iconEs',
      component: _IconField["default"],
      label: "Icon (Es)",
      disabled: !isSpanish
    })));
  }
  function renderHeaderFields() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].twoColumnForm
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].field
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: prefix + '.headerEn'
    }, function (fieldProps) {
      return isEnglish ? /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdWysiwyg, _extends({}, fieldProps, {
        label: "Header (En)",
        type: "input",
        settings: {
          toolbar: wysiwygToolbar
        }
      })) : /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdInput, _extends({}, fieldProps, {
        disabled: true,
        label: "Header (En)"
      }));
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].field
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: prefix + '.headerEs'
    }, function (fieldProps) {
      return isSpanish ? /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdWysiwyg, _extends({}, fieldProps, {
        label: "Header (Es)",
        type: "input",
        settings: {
          toolbar: wysiwygToolbar
        }
      })) : /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdInput, _extends({}, fieldProps, {
        disabled: true,
        label: "Header (Es)"
      }));
    })));
  }
  function renderTitleFields() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].twoColumnForm
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].field
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: prefix + '.titleEn'
    }, function (fieldProps) {
      return isEnglish ? /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdWysiwyg, _extends({}, fieldProps, {
        label: "Title (En)",
        type: "input",
        settings: {
          toolbar: wysiwygToolbar
        }
      })) : /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdInput, _extends({}, fieldProps, {
        disabled: true,
        label: "Title (En)"
      }));
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].field
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: prefix + '.titleEs'
    }, function (fieldProps) {
      return isSpanish ? /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdWysiwyg, _extends({}, fieldProps, {
        label: "Title (Es)",
        type: "input",
        settings: {
          toolbar: wysiwygToolbar
        }
      })) : /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdInput, _extends({}, fieldProps, {
        disabled: true,
        label: "Title (Es)"
      }));
    })));
  }
  function renderSelectedLessons(selectedMap, fieldArrayBag) {
    var surveyHandles = Object.keys(selectedMap);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].lessonListSelected
    }, surveyHandles.map(function (handle, lessonIndex) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: handle,
        className: _style["default"].lesson
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: _style["default"].button,
        onClick: function onClick() {
          var pinnedContent = (0, _get2["default"])(formikBag, "values.".concat(values.currentPrefix, ".pinnedContent.").concat(index, ".").concat(handle), []) || [];
          if (Array.isArray(pinnedContent) && pinnedContent.length > 0) {
            (0, _cccisdConfirm["default"])({
              message: 'Are you sure?',
              description: /*#__PURE__*/_react["default"].createElement("span", null, "Are you sure you want to remove lesson ", /*#__PURE__*/_react["default"].createElement("b", null, selectedMap[handle]), "? This will also delete all Pinned Content associated with this lesson."),
              confirmLabel: 'Yes',
              abortLabel: 'No'
            }).then(function () {
              removeLesson(fieldArrayBag, surveyHandles, handle);
            }).fail(function () {
              // Do nothing
            });
          } else {
            removeLesson(fieldArrayBag, surveyHandles, handle);
          }
        },
        type: "button"
      }, /*#__PURE__*/_react["default"].createElement(_backspace["default"], null)), /*#__PURE__*/_react["default"].createElement("button", {
        className: _style["default"].button,
        disabled: lessonIndex === 0,
        onClick: function onClick() {
          fieldArrayBag.swap(lessonIndex, lessonIndex - 1);
          fieldArrayBag.form.setFieldTouched('lessonsChanged', true);
        },
        type: "button"
      }, /*#__PURE__*/_react["default"].createElement(_arrowUp["default"], null)), /*#__PURE__*/_react["default"].createElement("button", {
        className: _style["default"].button,
        disabled: lessonIndex === surveyHandles.length - 1,
        onClick: function onClick() {
          fieldArrayBag.swap(lessonIndex, lessonIndex + 1);
          fieldArrayBag.form.setFieldTouched('lessonsChanged', true);
        },
        type: "button"
      }, /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null)), /*#__PURE__*/_react["default"].createElement("p", null, selectedMap[handle]));
    }));
  }
  function renderLessonsField() {
    return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.FieldArray, {
      name: "".concat(prefix, ".surveyHandles")
    }, function (fieldArrayBag) {
      // 2 loops is faster than nested loops
      var selectedMap = {};
      var notSelectedMap = {};
      var selectedHandles = (0, _get2["default"])(fieldArrayBag, 'form.values.' + fieldArrayBag.name, []) || [];
      selectedHandles.forEach(function (handle) {
        selectedMap[handle] = true;
      });
      surveys.forEach(function (surv) {
        if (selectedMap[surv.surveyHandle]) {
          selectedMap[surv.surveyHandle] = surv.label;
        } else {
          notSelectedMap[surv.surveyHandle] = surv.label;
        }
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "mb-3 ".concat(_style["default"].lessons)
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label"
      }, "Lessons"), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].twoColumnForm
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].field
      }, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("small", null, "Click to add lessons to this module.")), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].lessonList
      }, Object.keys(notSelectedMap).map(function (handle) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: handle,
          className: _style["default"].lesson,
          onClick: function onClick() {
            fieldArrayBag.push(handle);
            fieldArrayBag.form.setFieldTouched('lessonsChanged', true);
            (0, _helpers.addPinnedContentLesson)(formikBag, index, handle);
          }
        }, /*#__PURE__*/_react["default"].createElement("p", null, notSelectedMap[handle]), /*#__PURE__*/_react["default"].createElement("button", {
          className: _style["default"].button,
          type: "button"
        }, /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], {
          spaceLeft: true
        })));
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].field
      }, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("small", null, "Click the arrows to reorder selected lessons.")), renderSelectedLessons(selectedMap, fieldArrayBag))));
    });
  }
  function renderAdvancedSettings() {
    var isMustTakeInOrder = (0, _get2["default"])(values, "".concat(values.currentPrefix, ".mustTakeInOrder"), false);
    if (isMustTakeInOrder) {
      return;
    }
    return /*#__PURE__*/_react["default"].createElement(_Advanced["default"], {
      assignmentData: assignmentData,
      index: index,
      formikBag: formikBag
    });
  }
  function renderExpandButton(_ref2) {
    var isAtBottom = _ref2.isAtBottom;
    var margin = '0px';
    if (isAtBottom) {
      margin = '0px 0px 0px 7px';
    } else if (isExpanded) {
      margin = '0px 0px 22px -6px';
    } else {
      margin = '0px 0px 0px -6px';
    }
    return /*#__PURE__*/_react["default"].createElement("button", {
      className: 'btn btn-xs btn-link ' + _style["default"].expandButton,
      type: "button",
      onClick: function onClick() {
        return setIsExpanded(index, !isExpanded);
      },
      style: {
        margin: margin
      }
    }, isExpanded ? /*#__PURE__*/_react["default"].createElement("span", null, isAtBottom ? /*#__PURE__*/_react["default"].createElement(_arrowUp2["default"], null) : /*#__PURE__*/_react["default"].createElement(_arrowDown2["default"], null), "Collapse") : /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_arrowRight2["default"], null), "Expand"));
  }
  return /*#__PURE__*/_react["default"].createElement("div", null, hasError && /*#__PURE__*/_react["default"].createElement("span", {
    className: 'text-danger ' + _style["default"].moduleErrorIcon
  }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
    title: "This module has an error"
  }, /*#__PURE__*/_react["default"].createElement(_warning["default"], null))), displayHeader && /*#__PURE__*/_react["default"].createElement("h6", null, displayHeader), displayTitle && /*#__PURE__*/_react["default"].createElement("h4", null, displayTitle), renderExpandButton({
    isAtBottom: false
  }), isExpanded && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, renderIconFields(), renderHeaderFields(), renderTitleFields(), renderLessonsField(), renderAdvancedSettings(), /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-danger",
    type: "button",
    onClick: function onClick() {
      (0, _cccisdConfirm["default"])({
        message: 'Are you sure?',
        description: /*#__PURE__*/_react["default"].createElement("span", null, "Are you sure you want to delete ", /*#__PURE__*/_react["default"].createElement("b", null, displayTitle || displayHeader), "? This will also delete all Pinned Content associated with this module."),
        confirmLabel: 'Yes',
        abortLabel: 'No'
      }).then(function () {
        deleteModule();
      }).fail(function () {
        // Do nothing
      });
    }
  }, /*#__PURE__*/_react["default"].createElement(_bin["default"], {
    spaceRight: true
  }), "Delete Module"), renderExpandButton({
    isAtBottom: true
  })));
};
var _default = exports["default"] = ModuleContent;